<template>
  <v-expansion-panel
    v-if="isMobile && doctor"
    class="expansion-panel elevation-0"
  >
    <v-expansion-panel-header
      expand-icon="ui-icon-arrow-down"
      class="px-2"
    >
      <div class="d-flex">
        <div class="lpu-order text-subtitle-1" />
        <div>
          <div class="text-subtitle-1">
            {{ transDynamic(lpuAddress.lpu, `name,${currentLanguageIso},${needTranslate}`) }}
          </div>
          <template v-if="filterType !== 'telemed'">
            <v-expand-transition>
              <div
                v-if="!isExpanded"
                class="text-body-2 text-secondary--text"
              >
                {{ fullAddress }}
              </div>
            </v-expand-transition>
          </template>
        </div>
      </div>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <AppointmentRestrictionsBanner
        v-if="lpuAddress.has_restriction_appointment"
        class="mb-3"
        @open-appointment-restrictions="emit('open-appointment-restrictions', lpuAddress.lpu)"
      />
      <WorkplaceOrServiceSelect
        v-if="workplaces.length || services.length"
        :lpu-id="lpuAddress.lpu.id"
        :data-lpu-addr-id="lpuAddress.id"
        :init-speciality-translit="doctor.spec.translit"
      />
      <DoctorPriceBlock
        v-show="filterType !== 'home'"
        :page-type="filterType"
        :price="selectedItemPriceList[defaultPricePropertyName]"
        :club-price="selectedItemPriceList.priceClub"
        :telemed-medtochka-price="selectedItemPriceList.priceMedtochkaTelemed"
        :tab-is-free-with-treatment="selectedItem.workplace?.tab_is_free_with_treatment"
        speciality-selected
        class="mt-4"
        @update:redirect-value="handlePriceBlockUpdateRedirectValue"
      />
      <LpuLoyaltyProgram
        v-if="lpuAddress.lpu.lpu_loyalty_program && filterType === 'clinic'"
        class="my-3"
        :bonus-levels="lpuAddress.lpu.lpu_loyalty_program.levels"
        :max-payment-percent="lpuAddress.lpu.lpu_loyalty_program.max_payment_percent"
        :welcome-bonus-amount="lpuAddress.lpu.lpu_loyalty_program.welcome_bonus_amount"
        use-label
      />
      <WorkplaceOrServiceCalendar
        v-if="workplaces.length || services.length"
        class="mt-3 mb-10"
        :lpu-address="lpuAddress"
      />
      <template v-if="filterType !== 'telemed'">
        <div
          v-ripple
          class="d-flex align-center text-body-1 py-2 cursor-pointer"
          @click="handlePopupMapButtonClick"
        >
          <v-icon
            size="20"
            class="mr-4"
            color="icon-secondary"
          >
            ui-icon-map-pin
          </v-icon>
          {{ fullAddress }}
          <v-spacer />
          <v-icon>
            ui-icon-arrow-right
          </v-icon>
        </div>
        <DoctorPageLpuListMetroList
          v-if="lpuAddress.lpu.lpumetro_set.all.length"
          class="mt-2"
          :lpu-address="lpuAddress"
        />
      </template>
      <DoctorPageLpuListPhone :lpu-address="lpuAddress" />
      <a
        v-ripple
        :href="lpuUrl"
        class="d-flex align-center text-decoration-none text-body-1 py-2 mt-2"
      >
        <v-icon
          size="20"
          class="mr-4"
          color="icon-secondary"
        >
          ui-icon-home-ProDoctorov
        </v-icon>
        {{ t('Страница клиники', options) }}
        <v-spacer />
        <v-icon>
          ui-icon-arrow-right
        </v-icon>
      </a>
      <BannerMtLink
        v-if="isBannerMtLinkVisible"
        class="mt-4"
        :text="t('К врачу можно приходить с электронной медкартой', options)"
      />
    </v-expansion-panel-content>
  </v-expansion-panel>
  <div
    v-else-if="doctor"
    class="doctor-page-list-lpu pa-6"
  >
    <BannerMtLink
      v-if="isBannerMtLinkVisible"
      class="mb-6"
      :text="t('К врачу можно приходить с электронной медкартой', options)"
    />
    <div class="d-flex">
      <v-sheet
        class="d-flex flex-column"
        width="336"
      >
        <a
          class="text-subtitle-1 primary--text text-decoration-none"
          :href="lpuUrl"
        >{{ transDynamic(lpuAddress.lpu, `name,${currentLanguageIso},${needTranslate}`) }}</a>
        <div
          v-if="isUserStaff"
          class="mt-4"
        >
          <a
            class="adminka"
            :href="`${urls?.problemsWithSlots}?lpu_id=${lpuAddress.lpu.id}&doctor_id=${lpuAddress.doctor_id}`"
            target="_blank"
            rel="noopener noreferrer"
          >Проблемы с расписанием</a>
        </div>
        <AppointmentRestrictionsBanner
          v-if="lpuAddress.has_restriction_appointment"
          class="mt-6"
          @open-appointment-restrictions="emit('open-appointment-restrictions', lpuAddress.lpu)"
        />
        <WorkplaceOrServiceSelect
          v-if="workplaces.length || services.length"
          class="mt-6"
          :label="t('Специальность или услуга', options)"
          :lpu-id="lpuAddress.lpu.id"
          :data-lpu-addr-id="lpuAddress.id"
          :init-speciality-translit="doctor.spec.translit"
        />
        <DoctorPriceBlock
          v-show="filterType !== 'home'"
          :page-type="filterType"
          :price="selectedItemPriceList[defaultPricePropertyName]"
          :club-price="selectedItemPriceList.priceClub"
          :telemed-medtochka-price="selectedItemPriceList.priceMedtochkaTelemed"
          :tab-is-free-with-treatment="selectedItem.workplace?.tab_is_free_with_treatment"
          speciality-selected
          class="mt-4"
          @update:redirect-value="handlePriceBlockUpdateRedirectValue"
        />
        <LpuLoyaltyProgram
          v-if="lpuAddress.lpu.lpu_loyalty_program && filterType === 'clinic'"
          class="mt-3"
          :bonus-levels="lpuAddress.lpu.lpu_loyalty_program.levels"
          :max-payment-percent="lpuAddress.lpu.lpu_loyalty_program.max_payment_percent"
          :welcome-bonus-amount="lpuAddress.lpu.lpu_loyalty_program.welcome_bonus_amount"
          use-label
        />
        <template v-if="filterType !== 'telemed'">
          <div
            v-ripple
            class="d-flex align-center text-body-1 primary--text py-2 cursor-pointer mt-4"
            @click="handlePopupMapButtonClick"
          >
            <v-icon
              size="20"
              class="mr-4"
              color="icon-secondary"
            >
              ui-icon-map-pin
            </v-icon>
            <template v-if="isUserStaff">
              <div>
                <span class="text--text">
                  {{ lpuAddress.lpu.town.translit !== townTranslit ? `${props.lpuAddress.lpu.town.name},` : '' }}
                </span>
                {{ transDynamic(lpuAddress, `address,${currentLanguageIso},${needTranslate}`) }}
              </div>
            </template>
            <template v-else>
              {{ fullAddress }}
            </template>
          </div>
          <DoctorPageLpuListMetroList
            v-if="lpuAddress.lpu.lpumetro_set.all.length"
            class="mt-2"
            :lpu-address="lpuAddress"
          />
        </template>
        <DoctorPageLpuListPhone :lpu-address="lpuAddress" />
      </v-sheet>
      <v-spacer />
      <v-sheet width="389">
        <WorkplaceOrServiceCalendar
          v-if="workplaces.length || services.length"
          :lpu-address="lpuAddress"
        />
      </v-sheet>
    </div>
  </div>
</template>

<script setup lang="ts">
import I18NextVue from 'i18next'
import type { LpuAddressList } from 'www/vue_components/common/DoctorPageLpuList/types'
import { storeToRefs } from 'pinia'
import { computed, watch } from 'vue'
import { dispatchCustomEventGlobally, getFormattedPrice } from 'www/utils'
import transDynamic from 'djanjucks/filters/transDynamic'
import { POPUP_MAP_EVENTS, type RedirectValue } from 'www/constants'
import { useDoctorPageLpuListStore, useExternalDataStore } from 'www/vue_components/common/DoctorPageLpuList/stores'
import {
  WorkplaceOrServiceCalendar,
  WorkplaceOrServiceSelect,
} from 'www/vue_components/common/DoctorPageLpuList/components/DoctorAppointmentCard/components'
import { useDoctorAppointmentCardStore } from 'www/vue_components/common/DoctorPageLpuList/components/DoctorAppointmentCard/stores'
import AppointmentRestrictionsBanner from 'www/vue_components/common/AppointmentRestrictionsBanner/AppointmentRestrictionsBanner.vue'
import DoctorPageLpuListMetroList from 'www/vue_components/common/DoctorPageLpuList/components/DoctorPageLpuListMetroList.vue'
import DoctorPageLpuListPhone from 'www/vue_components/common/DoctorPageLpuList/components/DoctorPageLpuListPhone.vue'
import BannerMtLink from 'www/vue_components/common/BannerMtLink/components/common/BannerMtLink.vue'
import DoctorPriceBlock from 'www/vue_components/common/DoctorPriceBlockV2/DoctorPriceBlock.vue'
import { getPriceList } from 'www/vue_components/common/DoctorPageLpuList/functions'
import {
  getSpecialityAgesText,
  getWorkplaceNonNullPrices,
} from 'www/vue_components/common/DoctorPageLpuList/components/DoctorAppointmentCard/functions'
import LpuLoyaltyProgram from 'src/components/common/LpuLoyaltyProgram/LpuLoyaltyProgram.vue'

const hashSpecialityTranslit = window.location.hash.match(/speciality=([a-z-]+)/)?.[1]

const props = defineProps<{
  lpuAddress: LpuAddressList[number]
  isExpanded?: boolean
}>()

const { t, language } = I18NextVue
const options = { ns: language }

type Emits = {
  (_e: 'open-appointment-restrictions', _lpu: LpuAddressList[number]['lpu']): void,
}

const emit = defineEmits<Emits>()

const currentLanguageIso = window.LANGUAGE_DATA.currentLanguage.iso
const needTranslate = true

const externalDataStore = useExternalDataStore()
const {
  currentDate,
  doctor,
  synonymPriceList,
  townTranslit,
  urls,
  isMobile,
} = storeToRefs(externalDataStore)

const doctorAppointmentCardStore = useDoctorAppointmentCardStore(props.lpuAddress.lpu.id)()

doctorAppointmentCardStore.lpuAddress = props.lpuAddress
doctorAppointmentCardStore.lpuId = props.lpuAddress.lpu.id
doctorAppointmentCardStore.doctorId = props.lpuAddress.doctor_id || 0
doctorAppointmentCardStore.timedelta = props.lpuAddress.lpu.town.timedelta || 0
doctorAppointmentCardStore.hasSlots = props.lpuAddress.has_slots
doctorAppointmentCardStore.workplaces = props.lpuAddress.workplaces.filter(workplace => workplace.price !== null)
doctorAppointmentCardStore.services = synonymPriceList.value
  ?.filter(synonymPrice => synonymPrice.lpu.id === props.lpuAddress.lpu.id) || []

if (currentDate) {
  doctorAppointmentCardStore.nowDateString = currentDate.value
}

const {
  selectedItem,
  selectedItemPriceList,
  redirectValue,
  workplaces,
  workplacesWithSelectedFilterType,
  services,
} = storeToRefs(doctorAppointmentCardStore)
const { requestCalendarSlots } = doctorAppointmentCardStore

const doctorPageLpuListStore = useDoctorPageLpuListStore()
const { filterType } = storeToRefs(doctorPageLpuListStore)

const defaultPricePropertyName = computed(() => (({
  clinic: 'price',
  home: 'priceHome',
  telemed: 'priceOnline',
} as const)[filterType.value]))

function handlePriceBlockUpdateRedirectValue(newRedirectValue: RedirectValue) {
  redirectValue.value = newRedirectValue
}

const eventNameOpenPopup = isMobile.value ? POPUP_MAP_EVENTS.openMobile : POPUP_MAP_EVENTS.openDesktop

const lpuUrl = computed(() => {
  const { lpu } = props.lpuAddress

  if (!urls.value || !lpu.translit) {
    return '/'
  }

  return urls.value.$lpu
    .replace('lpu-town-translit', lpu.town.translit)
    .replace('lpu-translit', lpu.translit)
})

const fullAddress = computed(() => `${
  props.lpuAddress.lpu.town.translit !== townTranslit.value
    ? `${props.lpuAddress.lpu.town.name},`
    : ''
} ${
  transDynamic(props.lpuAddress, `address,${currentLanguageIso},${needTranslate}`)
}`)

const isUserStaff = window.USER.isStaff

const isBannerMtLinkVisible = computed(() => props.lpuAddress.lpu.uses_mtlink && filterType.value === 'clinic')

function handlePopupMapButtonClick() {
  window.history.pushState(null, '', new URL('', window.location.href))
  dispatchCustomEventGlobally(eventNameOpenPopup, {
    lpusData: [{
      coords: [props.lpuAddress.lat, props.lpuAddress.lon],
      name: props.lpuAddress.lpu.name,
      address: props.lpuAddress.address,
      id: String(props.lpuAddress.lpu.id),
      lpuHref: lpuUrl,
    }],
  })
}

const workplaceWithClub = computed(() => workplaces.value.find(workplace => typeof getPriceList(workplace)?.priceClub === 'number'))
const workplaceWithSelectedFilterType = computed(() => workplacesWithSelectedFilterType.value[0])
const workplaceWithSpecialityFromHash = computed(() => {
  const specialityTranslit = hashSpecialityTranslit ?? doctor.value?.spec.translit

  if (!specialityTranslit) {
    return null
  }

  return workplacesWithSelectedFilterType.value.find(workplace => workplace.spec.translit === specialityTranslit)
})

function setSelectedItem(isInitial = false) {
  let isItemSelected = false

  if (workplaces.value.length) {
    let selectedWorkplace = workplaceWithSpecialityFromHash.value

    if (!selectedWorkplace) {
      const defaultSelectedWorkplace = workplaceWithSelectedFilterType.value || workplaces.value[0]

      selectedWorkplace = filterType.value === 'clinic'
        ? workplaceWithClub.value || defaultSelectedWorkplace
        : defaultSelectedWorkplace
    }

    if (selectedWorkplace) {
      const nonNullPrices = getWorkplaceNonNullPrices(selectedItemPriceList.value)

      selectedItem.value = {
        workplace: selectedWorkplace,
        price: getFormattedPrice(Math.min(...nonNullPrices)),
        agesText: getSpecialityAgesText({
          min: selectedWorkplace.age_min,
          max: selectedWorkplace.age_max,
        }),
        isWorkplace: true,
      }

      isItemSelected = true
    }
  }

  if (services.value.length && !isItemSelected) {
    const selectedService = services.value[0]

    selectedItem.value = {
      service: selectedService,
      price: getFormattedPrice(selectedService.price),
      agesText: getSpecialityAgesText({
        min: selectedService.age_min,
        max: selectedService.age_max,
      }),
      isWorkplace: false,
    }

    if (isInitial) {
      requestCalendarSlots()
    }
  }
}

watch(filterType, () => {
  if (workplaceWithSelectedFilterType.value) {
    setSelectedItem()
  }
})

setSelectedItem(true)
</script>

<style scoped lang="scss">
@import '~www/themes/doctors/common/variables';

.expansion-panel {
  &.v-expansion-panel::before {
    box-shadow: initial;
  }

  :deep(.v-expansion-panel-content__wrap) {
    padding: 0 8px 8px !important;
  }
}

:deep(.v-expansion-panel-content__wrap) {
  padding-left: 16px;
  padding-right: 16px;
}

.doctor-page-list-lpu {
  &:not(:last-child) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  }
}
</style>
